export type EventInputStateTokens = {
	background: string;
};

/** Event input-state panel background (`css/eventInputState`). */
export default {
	background: '{neutral.200}',
} satisfies EventInputStateTokens;
